<template>
  <div class="chuKuZuoyeWarp">
    <div class="formBox" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
          <el-form-item label="创建时间:" class="item2"  >
                <el-date-picker
                  style="width:420px"
                  v-model="createTimes"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
          <template v-for="(column,index) in searchList" >
              <el-form-item label="运单编号:"   v-if="column.enName=='wayNo'&&(index<seacrchNum||topShow)" :key="column.enName" class="item1">
                 <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNos" ></el-input>
              </el-form-item>
              <el-form-item label="账单编号:"   v-else-if="column.enName=='yfSettlementBillNo'&&(index<seacrchNum||topShow)" :key="column.enName" class="item1">
                  <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.zdh" ></el-input>
              </el-form-item>
               <el-form-item label="外部单号:"   v-else-if="column.enName=='externalOrderNumber'&&(index<seacrchNum||topShow)" :key="column.enName" class="item1">
                  <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.wbdh" ></el-input>
              </el-form-item>
              <el-form-item label="签收时间:" class="item2"  v-else-if="column.enName=='actualSigningTimeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                 <el-date-picker
                  style="width:420px"
                  v-model="actualSignings"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="装车时间:" class="item2"  v-else-if="column.enName=='actualLoadingTimeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                  <el-date-picker
                  style="width:420px"
                  v-model="actualLoadingDate"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="开票时间:" class="item2"  v-else-if="column.enName=='yfInvoiceTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                  <el-date-picker
                  style="width:420px"
                  v-model="yfInvoiceTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="支出方式:" v-else-if="column.enName=='expenditurePatternName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.expenditurePattern" clearable placeholder="请选择支出方式">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in incomeList" :key="item.id" :label="item.showName" :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算状态:"  v-else-if="column.enName=='yfSettlementStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.yfSettlementStates" placeholder="请选择结算状态">
                  <el-option v-for="item in yfSettlementList" :label="item.showName" :key="item.value"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开票状态:"  v-else-if="column.enName=='yfInvoicingStatesName'&&(index<seacrchNum||topShow)" :key="column.enName">
                 <el-select v-model="searchFrom.yfInvoicingStates" placeholder="请选择开票状态">
                    <el-option v-for="item in yfInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="货物类型:"  v-else-if="column.enName=='productTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.productTypeName" placeholder="请选择货物类型">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务部门:"  v-else-if="column.enName=='businessUnit'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.businessUnit" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称:"  v-else-if="column.enName=='projectType'&&(index<seacrchNum||topShow)" :key="column.enName">
                 <el-select v-model="searchFrom.projectType" filterable placeholder="请选择">
                <el-option  label="全部" value="" ></el-option>
                <el-option v-for="item in xmList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
              </el-select>
              </el-form-item>
              <el-form-item label="创建部门:"  v-else-if="column.enName=='createSubdepartmentName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.createSubdepartmentName" placeholder="请选择">
                  <el-option label="全部" value="" ></el-option>
                  <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
               <template  v-else>
                 <el-form-item :label="column.cnName+':'" v-if="(index<seacrchNum||topShow)" :key="column.enName">
                  <el-input placeholder="" v-model="searchFrom[column.enName]" ></el-input>
                </el-form-item>
              </template>
           </template>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div style="">
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
              <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
              <el-button type="primary" size="mini" :disabled="isDisable" @click="daochuFN">导出</el-button>
              <!-- <el-button type="primary" size="mini" @click="TSFKfn" v-if="btnFlg[1]" >推送付款风控</el-button> -->
              <el-button type="primary" size="mini" @click="duizhang" v-if="btnFlg[0]">对账</el-button>
              <el-button type="primary" size="mini" @click="tiaojiaFn" v-if="btnFlg[2]">一分调价</el-button>
            </el-form-item>
            <el-form-item>
              <div style="display:flex;">
                <p style="width:15px;height:15px;background:#f9bc04;margin-top: 6px;"></p>
                <span style="margin-left:5px;">超期未付款</span>
              </div>
            </el-form-item>
            <span>
              <el-form-item>
                <p class="margin0">支出总额合计：<span class="red">{{map.freightTaxTotalSum|moneyFormatNew}}</span>元</p>
              </el-form-item>
              <el-form-item>
                <p class="margin0">已选：<span class="red">{{duiZhangData.wayNumber}}</span>个运单</p>
              </el-form-item>
              <el-form-item>
                <p class="margin0">支出总额<span class="red">{{duiZhangData.totalAmount|moneyFormatNew}}</span>元</p>
              </el-form-item>
              <el-form-item>
                <p class="margin0">结算量<span class="red">{{duiZhangData.jiesuanliang}}</span>{{duiZhangData.danwei}}</p>
              </el-form-item>
            </span>
          </div>
          <div @click="tabSetting"><i class="el-icon-s-tools"></i></div>
        </div>
      </el-form>
    </div>
     <div class="openBox">
      <div class="openChild" v-if="topShow" @click="topFn">
        <i class="el-icon-caret-top" ></i>
      </div>
      <div class="openChild" v-if="!topShow" @click="topFn">
        <i class="el-icon-caret-bottom" ></i>
      </div>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" v-if="tabHeadList.length>0" ref="tabref" class="elTab" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}" @selection-change='selectGoods' :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="50" fixed></el-table-column>
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
         <template v-for="column in tabHeadList">
          <template v-if="column.enName=='yfSettlementStatesName'">
            <el-table-column prop="" label="结算状态" width="100" :key="column.enName">
              <template scope="scope">
                <span class="wsStyle" v-show="scope.row.yfSettlementStates == '-1'">未对账</span>
                <span class="wsStyle" v-show="scope.row.yfSettlementStates == '0'">未付款</span>
                <span class="bfStyle" v-show="scope.row.yfSettlementStates == '1'">部分付款</span>
                <span class="ysStyle" v-show="scope.row.yfSettlementStates == '2'">已付款</span>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='yfInvoicingStatesName'">
            <el-table-column prop="" label="开票状态" width="100" :key="column.enName">
              <template scope="scope">
                <!-- 0.未开票、1.部分开票、2.已开票 -->
                <div>
                  <span class="wsStyle" v-show="scope.row.yfInvoicingStates == '0'">未开票</span>
                  <span class="bfStyle" v-show="scope.row.yfInvoicingStates == '1'">部分开票</span>
                  <span class="ysStyle" v-show="scope.row.yfInvoicingStates == '2'">已开票</span>
                  <span v-show="scope.row.yfInvoicingStates===null">-</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='freightUnitPriceName'">
              <el-table-column prop="" label="运费单价" width="130" :key="column.enName">
                <template scope="scope">
                  <div>
                    <span v-if="scope.row.freightPricingType == '0'">{{scope.row.freightUnitPrice}}元/吨</span>
                    <span v-if="scope.row.freightPricingType == '1'">
                      <span v-if="scope.row.freightUnitPrice != 0">{{scope.row.freightUnitPrice}}元/车</span>
                      <span v-else>-</span>
                    </span>
                    <span v-if="scope.row.freightPricingType == '2'">{{scope.row.freightUnitPrice}}元/方</span>
                    <span v-if="scope.row.freightPricingType == '3'">{{scope.row.freightUnitPrice}}元/件</span>
                    <span v-if="scope.row.freightPricingType == '' || scope.row.freightPricingType == null">-</span>
                  </div>
                </template>
              </el-table-column>
          </template>
          <template v-else-if="column.enName=='createTimeName'">
             <el-table-column :key="column.enName" prop="createTime" :label="column.cnName" :width="column.fieldWidth" :formatter="dateTimeFormat">
              </el-table-column>
          </template>
          <template v-else-if="column.enName=='actualLoadingTimeName'">
             <el-table-column :key="column.enName" prop="actualLoadingTime" :label="column.cnName" :width="column.fieldWidth" :formatter="dateTimeFormat">
              </el-table-column>
          </template>
          <template v-else-if="column.enName=='actualSigningTimeName'">
             <el-table-column :key="column.enName" prop="actualSigningTime" :label="column.cnName" :width="column.fieldWidth" :formatter="dateTimeFormat">
              </el-table-column>
          </template>
          <template v-else-if="column.enName=='yfInvoiceTime'">
             <el-table-column :key="column.enName" prop="yfInvoiceTime" :label="column.cnName" :width="column.fieldWidth" :formatter="dateTimeFormat">
              </el-table-column>
          </template>
          <template v-else>
            <el-table-column  :key="column.enName" :prop="column.enName" :label="column.cnName" :width="column.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
              <el-table-column v-for="item in column.child" :key="item.enName" :prop="item.enName" :label="item.cnName" :width="item.fieldWidth" :formatter="formatterRowEmpty">
              </el-table-column>
            </el-table-column>
          </template>
        </template>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100,200,300,500]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
     <!-- 一分调价 -->
    <el-dialog  title="一分调价" :close-on-click-modal="false" :close-on-press-escape="false"  @close="YFTJflag = false"  :visible.sync="YFTJflag" width="400px" center>
      <div>
        <el-form  :inline="true"   ref="YFTJform" :model="YFTJform"  class="demo-form-inline" style="text-align:center;"  label-width="80px"  size="mini"  >
          <el-form-item >
            <template>
              <el-radio v-model="YFTJform.type" :label="0">增加</el-radio>
              <el-radio v-model="YFTJform.type" :label="1">减少</el-radio>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="YFTJflag = false">取 消</el-button>
        <el-button type="primary" @click="YFTJsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 对账弹框 -->
    <duizhangMark v-if="duizhangMark" :duizhangMark.sync='duizhangMark' :duiZhangData = 'duiZhangData' :YSFlag='2' @refresh = 'chaxun'></duizhangMark>
    <!-- 设置表头 -->
    <table-heads v-if="tableMark" :tableMark.sync='tableMark' :groupCode="groupCode" @refresh = 'queryMyPageField'></table-heads>
    <export-setting v-if="exportMark" :exportMark.sync='exportMark' :groupCode="groupCode"
   @exportList='exportList'></export-setting>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findWayBusinessList, getDictionaryDetailList, addRiskControlInfo, findWayBusinessListTotal, updateFreightTotal, queryMyPageField } from '@/api/newTMS'
import { getCurrUserDepartment } from '@/api/newCrm'
import { emptyFn, dateTimeFormat, toFixed, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
import duizhangMark from '@/views/newTMS/publicFiles/duiZhangDialog.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import tableHeads from '@/views/newTMS/publicFiles/tableHeades.vue'
import exportSetting from '@/views/newTMS/publicFiles/exportSetting.vue'
export default {
  name: 'Freight',
  components: {
    duizhangMark, tableHeads, exportSetting
  },
  data () {
    return {
      groupCode: 'platformYfWayBusiness',
      tableMark: false,
      exportMark: false,
      tabHeadList: [],
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      toFixed: toFixed,
      loading: false,
      duizhangMark: false,
      incomeList: [],
      yfSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未对账',
          value: '-1'
        },
        {
          showName: '未付款',
          value: '0'
        },
        {
          showName: '部分付款',
          value: '1'
        },
        {
          showName: '已付款',
          value: '2'
        }
      ],
      yfInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未开票',
          value: '0'
        },
        {
          showName: '部分开票',
          value: '1'
        },
        {
          showName: '已开票',
          value: '2'
        }
      ],
      HWlist: [],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTimes: [],
      actualSignings: [],
      actualLoadingDate: [],
      yfInvoiceTime: [],
      searchFrom: {
        payerType: '1',
        yfSettlementStates: '-1',
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayNos: '',
        wayState: 4
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00J0100', '01N00J0D00', '01N00J0G00'],
      tableList: [],
      map: {
        freightTaxTotalSum: 0
      },
      duiZhangData: {
        wayNumber: 0, // 运单数量
        totalAmount: 0, // 选中的应收总额
        insideOutsideType: '1',
        makeTicketYn: '',
        settlementPattern: '',
        jiesuanliang: 0,
        danwei: '吨'
      },
      ids: [],
      isDisable: false,
      bumenList: [],
      YFTJflag: false,
      YFTJform: {},
      xmList: [],
      topShow: false,
      searchList: [],
      seacrchNum: window.innerWidth > 1680 ? 9 : 7
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yingFuSettlement')
    this.createTimes = getLastMonth()
    this.getList()
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.xmList = res })
    getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.incomeList = res })
    getCurrUserDepartment().then(res => { this.bumenList = res })
    this.queryMyPageField()
  },
  mounted () {
    this.getHeight()
  },
  methods: {
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 210) + 'px'
      })
    },
    topFn () {
      this.topShow = !this.topShow
      this.getHeight()
      this.seacrchNum = window.innerWidth > 1680 ? 10 : 8
    },
    tabSetting () {
      this.tableMark = true
    },
    // 查询我的页面表头
    queryMyPageField () {
      this.tabHeadList = []
      queryMyPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.tabHeadList = res
        this.searchList = this.tabHeadList.filter(item => item.isSettingQuery == 1)
        this.getHeight()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 一分调价
    tiaojiaFn () {
      let selectData = this.$refs.tabref.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].yfSettlementStates != -1) {
        this.$alert('请选择未对账的数据', '系统提示')
        return
      }

      this.YFTJflag = true
      this.YFTJform = {
        wayBusinessId: selectData[0].id,
        type: 0
      }
    },
    YFTJsaveFn () {
      this.$refs.YFTJform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateFreightTotal(this.YFTJform).then(res => {
            loading.close()
            this.YFTJflag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 推送风控平台
    TSFKfn () {
      let selectData = this.$refs.tabref.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let flagC = selectData.some(item => item.actualSigningTime == null)
      let flagE = selectData.some(item => item.riskControlState !== '0')
      if (flagC) {
        this.$alert('存在未签收的运单，请重新选择后再推送', '系统提示')
        return
      }
      if (flagE) {
        this.$alert('存在风控状态不是待推送的运单，请重新选择后再推送', '系统提示')
        return
      }
      this.$confirm('是否推送付款风控平台?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        let ids = selectData.map(itme => itme.wayId)
        addRiskControlInfo({
          wayIds: ids.toString(),
          wayNumber: selectData.length
        }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '推送成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    getTimes () {
      if (this.createTimes) {
        this.$set(this.searchFrom, 'createTimeStart', this.createTimes[0])
        this.$set(this.searchFrom, 'createTimeEnd', this.createTimes[1])
      } else {
        this.$set(this.searchFrom, 'createTimeStart', '')
        this.$set(this.searchFrom, 'createTimeEnd', '')
      }
      if (this.actualSignings) {
        this.$set(this.searchFrom, 'actualSigningTimeStart', this.actualSignings[0])
        this.$set(this.searchFrom, 'actualSigningTimeEnd', this.actualSignings[1])
      } else {
        this.$set(this.searchFrom, 'actualSigningTimeStart', '')
        this.$set(this.searchFrom, 'actualSigningTimeEnd', '')
      }
      if (this.actualLoadingDate) {
        this.$set(this.searchFrom, 'actualLoadingTimeStart', this.actualLoadingDate[0])
        this.$set(this.searchFrom, 'actualLoadingTimeEnd', this.actualLoadingDate[1])
      } else {
        this.$set(this.searchFrom, 'actualLoadingTimeStart', '')
        this.$set(this.searchFrom, 'actualLoadingTimeEnd', '')
      }
      if (this.yfInvoiceTime) {
        this.$set(this.searchFrom, 'yfInvoiceTimeStart', this.yfInvoiceTime[0])
        this.$set(this.searchFrom, 'yfInvoiceTimeEnd', this.yfInvoiceTime[1])
      } else {
        this.$set(this.searchFrom, 'yfInvoiceTimeStart', '')
        this.$set(this.searchFrom, 'yfInvoiceTimeEnd', '')
      }
      if (this.searchFrom.zdh) {
        let zdh = this.searchFrom.zdh.replace(/\n/g, ',')
        let zdhArr = zdh.split(',')
        this.searchFrom.yfBillNoList = zdhArr
        // if (zdhArr.length == 1) {
        //   this.searchFrom.billNo = zdhArr[0]
        // } else {
        //   this.searchFrom.billNos = zdhArr
        // }
      } else {
        this.searchFrom.yfBillNoList = null
      }
      if (this.searchFrom.wbdh) {
        let wbdh = this.searchFrom.wbdh.replace(/\n/g, ',')
        let wbdhArr = wbdh.split(',')
        this.searchFrom.listExternalOrderNumber = wbdhArr
      } else {
        this.searchFrom.listExternalOrderNumber = null
      }
    },
    // 获取列表
    getList () {
      this.loading = true
      this.getTimes()
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNos = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNos.split(',')
      } else {
        this.searchFrom.wayNos = ''
        this.searchFrom.wayNoList = null
      }
      findWayBusinessList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      findWayBusinessListTotal(this.searchFrom).then(res => {
        this.map = res
      })
    },
    tableRowClassName ({ row }) {
      let rowName = ''
      const timestamp = new Date().getTime()
      if (row.yfSettlementStates != '2') {
        if (row.generalPeriodDate) {
          if (row.generalPeriodDate < timestamp) {
            rowName = 'warning-row'
          } else {
            rowName = ''
          }
        }
      }
      return rowName
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 选择数据
    selectGoods (selection) {
      this.duiZhangData.wayNumber = 0
      console.log(selection, 'selection')
      this.duiZhangData.totalAmount = 0.00
      this.duiZhangData.jiesuanliang = 0.00
      this.ids = []
      this.duiZhangData.danwei = selection[0].measuringUnit
      selection.forEach((item, index) => {
        this.duiZhangData.totalAmount += item.freightTaxTotal
        this.duiZhangData.wayNumber = index + 1
        this.duiZhangData.jiesuanliang += item.liquidatedAmount
        this.ids.push(item.id)
      })
      // this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
      if (selection[0].measuringUnit == '件') {
        this.duiZhangData.jiesuanliang = this.toFixed(this.duiZhangData.jiesuanliang, 0)
      } else {
        this.duiZhangData.jiesuanliang = this.toFixed(this.duiZhangData.jiesuanliang, 3)
      }
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        payerType: '1',
        yfSettlementStates: '-1',
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        wayNos: '',
        wayNoList: null,
        zdh: '',
        wbdh: '',
        wayState: 4
      }
      // this.createTimes = []
      this.createTimes = getLastMonth()
      this.actualSignings = []
      this.actualLoadingDate = []
      this.yfInvoiceTime = []
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    duizhang () {
      let selectData = this.$refs.tabref.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let flagA = selectData.every(item => item.yfSettlementStates == '-1')
        let flagC = selectData.some(item => item.actualSigningTime == null)
        let flagD = selectData.some(item => item.onlineAddPushFlag == 1 || item.onlineAddPushFlag == 4)
        let flagE = selectData.some(item => !(item.riskControlState == 2 || item.riskControlState == 4))
        // if (flagE) {
        //   this.$alert('风控状态只能是不推送或者已处理，请重新选择后再对账', '系统提示')
        // } else
        console.log(flagD, 'flagD')
        if (!flagA) {
          this.$alert('只能选择未对账的数据', '系统提示')
        } else if (flagC) {
          this.$alert('存在未签收的运单，请重新选择后再对账', '系统提示')
        } else {
          this.duiZhangData.wayNumber = selectData.length
          this.ids = []
          this.duiZhangData.totalAmount = 0.00
          let payer = selectData[0].payer
          let expenditurePattern = selectData[0].expenditurePattern
          let makeTicketYn = selectData[0].makeTicketYn
          let businessUnit = selectData[0].businessUnit
          let flagB = selectData.every(item => {
            this.ids.push(item.id)
            this.duiZhangData.totalAmount += item.freightTaxTotal
            return item.payer == payer && item.expenditurePattern == expenditurePattern
          })
          this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
          if (flagB) {
            this.duizhangMark = true
            this.duiZhangData.makeTicketYn = selectData[0].makeTicketYn
            this.duiZhangData.settlementPattern = selectData[0].expenditurePattern
            this.$set(this.duiZhangData, 'ids', this.ids.toString())
          } else {
            this.$alert('请选择同一收款方、同一支出方式的数据', '系统提示')
          }
        }
      }
    },
    exportList (val) {
      this.getTimes()
      if (this.searchFrom.wayNos) {
        this.searchFrom.wayNos = this.searchFrom.wayNos.replace(/\n/g, ',')
        this.searchFrom.wayNoList = this.searchFrom.wayNos.split(',')
      } else {
        this.searchFrom.wayNos = ''
        this.searchFrom.wayNoList = null
      }
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportOutsideYfWayListForPz',
        form,
        '应付明细列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    daochuFN () {
      this.exportMark = true
    }
    // 导出
    // daochuFN () {
    //   // this.searchFrom.createTimeStart = this.createTimes[0]
    //   // this.searchFrom.createTimeEnd = this.createTimes[1]
    //   // this.searchFrom.actualSigningTimeStart = this.actualSignings[0]
    //   // this.searchFrom.actualSigningTimeEnd = this.actualSignings[1]
    //   this.getTimes()
    //   delete this.searchFrom.pageNo
    //   delete this.searchFrom.pageSize
    //   if (this.searchFrom.wayNos) {
    //     this.searchFrom.wayNos = this.searchFrom.wayNos.replace(/\n/g, ',')
    //     this.searchFrom.wayNoList = this.searchFrom.wayNos.split(',')
    //   } else {
    //     this.searchFrom.wayNos = ''
    //     this.searchFrom.wayNoList = null
    //   }
    //   exportExcel(
    //     this.global.tmsPlus + '/settlementBill/exportOutsideYfWayListForPz',
    //     this.searchFrom,
    //     '应付明细列表'
    //   )
    //   this.isDisable = true
    //   setTimeout(() => {
    //     this.isDisable = false // 点击一次时隔两秒后才能再次点击
    //   }, 2000)
    // }
  }
}
</script>
<style>
.el-table__body tr.warning-row > td {
  background-color: #f9bc04 !important;
}
</style>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}

</style>
